export default function ErdDiagram() {
  return (
    <div>
      <h2>Application Entity Relationship Diagram</h2>
      <a
        href="/AWMS_ERD.jpg"
        download
        className="inline-flex items-center rounded bg-black px-4 py-2 text-white transition hover:bg-blue-700"
      >
        Download Diagram
      </a>
    </div>
  );
}
